import { render, staticRenderFns } from "./FeaturesTables.vue?vue&type=template&id=c54c0dfa&lang=pug&"
import script from "./FeaturesTables.vue?vue&type=script&lang=js&"
export * from "./FeaturesTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports